














import Vue from 'vue';
import Component from 'vue-class-component';

import ToDoList from '@/components/santeEnfant/ToDoList.vue';
import Alimentation from '@/components/santeEnfant/Alimentation.vue';
import SonDeveloppement from '@/components/santeEnfant/SonDeveloppement.vue';
import Subheader from '@/components/santeEnfant/SubHeader.vue';
import InfosLegales from '@/components/santeEnfant/InfosLegales.vue';
import PromoEspaceSante from '@/components/PromoEspaceSante.vue';

const Props = Vue.extend({
	props: {
		jsonenfants: {
			type: String,
			default: ''
		},
		id: {
			type: String,
			default: ''
		},
		moisSel: {
			type: String,
			default: ''
		}
	}
});

@Component({
	components: {
		ToDoList,
		Alimentation,
		SonDeveloppement,
		Subheader,
		InfosLegales,
		PromoEspaceSante
	}
})
export default class HomeSanteEnfant extends Props {
	get enfant() {
		let Objectenfants = JSON.parse(atob(this.jsonenfants));
		return Objectenfants.enfant[this.id];
	}
}
